import React, { Component, PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import * as cartActions from '../actions'
import ReviewComponent from './ReviewComponent'
import { getCartItems, getSubTotal, getAddress, getPayment, getTax, getLocale, getisCartProcessing } from '../../../rootReducer'
import { URLS } from '../../constants'

class Review extends PureComponent {
  static propTypes = {
    subTotal: PropTypes.number,
    taxes: PropTypes.object,
    items: PropTypes.array,
    address: PropTypes.object,
    payment: PropTypes.object,
    locale: PropTypes.string,
    cartActions: PropTypes.object,
    updateRoute: PropTypes.func,
    isCartProcessing: PropTypes.bool,
  }
  handlePayment = () => {
    const {
      isCartProcessing,
    } = this.props
    if (!isCartProcessing) {
      this.props.cartActions.reviewOrder()
    }
  }
  handleAddressChange = () => {
    this.props.updateRoute(URLS.CHAT, URLS.ADDRESS)
  }
  handlePaymentChange = () => {
    this.props.updateRoute(URLS.CHAT, URLS.PAYMENT)
  }
  render() {
    const {
      subTotal, items, address, payment, taxes, locale, isCartProcessing,
    } = this.props
    return (
      <ReviewComponent
        subTotal={subTotal}
        taxes={taxes}
        items={items}
        total={subTotal + taxes}
        payment={payment}
        address={address}
        locale={locale}
        isCartProcessing={isCartProcessing}
        handleAddressChange={this.handleAddressChange}
        handlePaymentChange={this.handlePaymentChange}
        handlePayment={this.handlePayment}
      />
    )
  }
}

const mapDispatchToProps = dispatch => ({
  cartActions: bindActionCreators(cartActions, dispatch),
})

const mapStateToProps = state => ({
  items: getCartItems(state),
  subTotal: getSubTotal(state),
  address: getAddress(state),
  payment: getPayment(state),
  taxes: getTax(state),
  locale: getLocale(state),
  isCartProcessing: getisCartProcessing(state),
})

export const ReviewContainer = connect(mapStateToProps, mapDispatchToProps)(Review)



// WEBPACK FOOTER //
// ./src/containers/Cart/Review/ReviewContainer.js